import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';

export default ({ node }) => {
  return <ReactMarkdown source={node.body} />;
};
